export default "__VITE_ASSET__EjruDlKt__"